import React from 'react';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';

export default function PopupSuccess(props) {
    return (
        <div className='remove-service-popup'>
            <div className='popup-title'> ההסרה בוצעה בהצלחה </div>
            <div className='popup-description'> ההסרה תתעדכן במנוי במהלך יום עסקים, עד אז אפשר להמשיך להשתמש בשירות </div>
            <div className='popup-button-wrapper'> <BtnSubmit text='סגירה' onclick={props.onClose} formid='service-details-popup' /> </div>
        </div>
    );
};

